<div class="travel-loader-cont {{classType}}" [class.isDesktop]="!isMobile">
    <div class="img-cont">
        <ng-lottie 
          width="200px" 
          height="200px" 
          [options]="options" 
          [styles]="styles">
        </ng-lottie>
    </div>
</div>